import React from 'react'
import { Stage, Sprite, } from "@inlet/react-pixi";
import SigantureImgData from "./siganture-img-data"
export default function PixiContainer({
  widthFull,
  heightFull,
  heightImgSignature,
  widthImgSignature,
  item,
  imgSignature,
  newImg
}) {
  const onDragStart = (event) => {
    const sprite = event.currentTarget;
    sprite.alpha = 0.5;
    sprite.data = event.data;
    sprite.dragging = true;
  };
  const onDragEnd = (event) => {
    const sprite = event.currentTarget;
    sprite.alpha = 1;
    sprite.dragging = false;
    sprite.data = null;
  };
  const onDragMove = (event) => {
    const sprite = event.currentTarget;
    if (sprite.dragging) {
      const newPosition = sprite.data.getLocalPosition(sprite.parent);
      sprite.x = newPosition.x;
      sprite.y = newPosition.y;
      SigantureImgData.x = sprite.x
      SigantureImgData.y = sprite.y
      SigantureImgData.sprite = {
        x: sprite.x,
        y: sprite.y,
        width: widthImgSignature,
        height: heightImgSignature,
      }
      SigantureImgData.imgSignature = newImg
    }
  };
  return (
    <Stage
      width={widthFull}
      height={heightFull}
      options={{ backgroundColor: 'white' }}
    >
      <Sprite
        image={item}
        x={0}
        y={0}
        width={widthFull}
        height={heightFull}
      />
      <Sprite
        image={imgSignature}
        x={100}
        y={300}
        anchor={0.5}
        interactive
        buttonMode
        pointerdown={onDragStart}
        pointerup={onDragEnd}
        pointerupoutside={onDragEnd}
        pointermove={onDragMove}
        width={widthImgSignature}
        height={heightImgSignature}
      />
    </Stage>
  )
}
